import { cn } from "../../lib/utils";

/**
 * Green uppercase eyebrow label.
 *
 * The short leading rule was removed at the client's request. `tone` is kept
 * because callers already pass it; it now affects only the text colour.
 */
export default function Eyebrow({ children, className, tone = "green" }) {
  const color = tone === "green" ? "text-emerald" : "text-mutedtext";

  return (
    <div
      className={cn(
        "inline-flex items-center text-eyebrow uppercase font-display font-bold",
        color,
        className
      )}
    >
      {children}
    </div>
  );
}
